import { connect } from 'react-redux';
import { signupAction } from '../../../api/user/actions/signup-action';
import { inviteAction } from '../../../api/user/actions/invite-action';
import { SignupPage, ExternalProps, ExternalActionProps } from './signup-page.component';
import {
  isLoadingSelector,
  signupSelector,
  shareableUrlSelector,
  tokenSelector,
  IsSignupVerifiedSelector,
  requestDefaultInviteCodeSelector,
  signupUsernameSelector,
  IsCreditSignupSelector,
  ShowPlayerProfileSettingsBonusSelector,
} from '../../../api/user/user.selector';
import { appSettingsSliceSelector } from '../../../utils/redux/slice-app-settings/app-settings-selector';

function mapStateToProps(state: any): ExternalProps {
  return {
    app_settings: appSettingsSliceSelector(state),
    is_credit: IsCreditSignupSelector(state),
    is_verified: IsSignupVerifiedSelector(state),
    isLoading: isLoadingSelector(state),
    request_default_invite_code: requestDefaultInviteCodeSelector(state),
    shareableUrl: shareableUrlSelector(state),
    show_player_profile_settings_bonus: ShowPlayerProfileSettingsBonusSelector(state),
    signupSuccess: signupSelector(state),
    token: tokenSelector(state),
    username: signupUsernameSelector(state),
  };
}

const mapDispatchToProps: ExternalActionProps = {
  signupAction,
  inviteAction,
};

export const SignupPageContainer = connect(mapStateToProps, mapDispatchToProps)(SignupPage);
